import { render, staticRenderFns } from "./revenue.vue?vue&type=template&id=0c4042ce&scoped=true"
import script from "./revenue.vue?vue&type=script&lang=js"
export * from "./revenue.vue?vue&type=script&lang=js"
import style0 from "./revenue.vue?vue&type=style&index=0&id=0c4042ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4042ce",
  null
  
)

export default component.exports